import { Component } from '@angular/core';
import { UtilsService } from './services/utils.service';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'appwebadminclientes';


	constructor(private utilsService:UtilsService){
		this.utilsService.obtenerIdDispositivo_main('AppComponent')
	}



}
